import React from 'react';
import { ClinicInput, MainSelect, AutosizeTextarea, MultiSelect } from '../../UI';
import { PropTypes } from 'prop-types';

const inputDirection = { dir: 'auto' };
export default function DynamicForm(props) {
    switch (props.type) {
        case 'text':
            return (
                <ClinicInput
                    dynamic={'true'}
                    label={props.label}
                    name={props.name}
                    type="text"
                    inputProps={inputDirection}
                />
            );
        case 'textarea':
            return (
                <AutosizeTextarea
                    dynamic={'true'}
                    label={props.label}
                    name={props.name}
                    rowsMax={8}
                    dir="auto"
                />
            );
        case 'radios':
            return (
                <MainSelect
                    dynamic={'true'}
                    options={props.choices}
                    name={props.name}
                    label={props.label}
                />
            );
        case 'checkboxes':
            return (
                <MultiSelect
                    dynamic={'true'}
                    selectItems={props.choices}
                    name={props.name}
                    label={props.label}
                />
            );

        default:
            return null;
    }
}
DynamicForm.propTypes = {
    type: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    choices: PropTypes.array
};
